<div class="limiter">
  <div class="container-login100">
    <div class="wrap-login100">
      <div class="login100-form ">
        <span class="login100-form-title p-b-43">
          Đăng nhập
        </span>
        <div class="login-box-content">
          <div class="fb-login box-shadow"></div>
          <div class="my-4">
            <button class="btn btn-outline-success btn-google btn-block mb-3 " (click)="goToLink()">
              <span class="icon-google1 mb-1"></span>
              <span style="color: black;">Đăng nhập bằng Google</span>
            </button>
          </div>
        </div>
        <form class="validate-form" action="{{contextPath}}/login" method="POST">
        <div><p class="center-or"> <span>Hoặc</span> </p></div>
        <div class="wrap-input100 validate-input" data-validate = "Valid email is required: ex@abc.xyz">
          <input class="input100 has-val" type="text" name="username">
          <span class="focus-input100"></span>
          <span class="label-input100">Email</span>
        </div>


        <div class="wrap-input100 validate-input" data-validate="Password is required">
          <input class="input100 has-val" type="password" name="password">
          <span class="focus-input100"></span>
          <span class="label-input100">Password</span>
        </div>

        <div class="flex-sb-m w-full p-t-3 p-b-32">
          <div class="contact100-form-checkbox">
            <input class="input-checkbox100" id="ckb1" type="checkbox" name="remember-me">
            <label class="label-checkbox100" for="ckb1">
              Remember me
            </label>
          </div>
        </div>
<br>
        <div class="container-login100-form-btn">

          <button class="login100-form-btn" >
            Đăng nhập
          </button>
        </div>

        <div class="text-center p-t-46 p-b-20">
          <span class="txt2">

          </span>
        </div>
      </form>
    </div>
      <div class="login100-more">
          <div class="img-bg"></div>
         <!-- <img src="assets/images/bg/bg-login.png">-->
      </div>

    </div>
  </div>
</div>
